import { render, staticRenderFns } from "./bind-patrol-equip.vue?vue&type=template&id=7391365f&scoped=true&"
import script from "./bind-patrol-equip.vue?vue&type=script&lang=ts&"
export * from "./bind-patrol-equip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7391365f",
  null
  
)

export default component.exports